
define('text!Magento_Checkout/template/summary/item/details/message.html',[],function () { return '<div class="cart item message notice" if="getMessage($parents[1])"><div data-bind="text: getMessage($parents[1])"></div></div>';});

